import * as React from 'react';

const ChecklistIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={32}
      height={32}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h32v32H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#004A68"
        d="M5.733 26.67a1.78 1.78 0 0 1-1.308-.54 1.78 1.78 0 0 1-.538-1.307V7.182c0-.512.18-.948.538-1.307a1.78 1.78 0 0 1 1.308-.54h20.533c.513 0 .948.18 1.307.54.36.359.54.795.54 1.307v17.641c0 .512-.18.948-.54 1.308a1.78 1.78 0 0 1-1.307.538H5.733Zm0-1.026h20.533c.205 0 .393-.086.564-.257.171-.17.257-.359.257-.564V7.182c0-.205-.086-.393-.257-.564-.17-.171-.359-.256-.564-.256H5.733c-.205 0-.393.085-.564.256-.171.17-.257.359-.257.564v17.641c0 .205.086.393.257.564.17.171.359.257.564.257Zm1.6-3.641h5.333v-1.334H7.333v1.334Zm12.066-2.95 5.652-5.65-.952-.952-4.7 4.734-1.9-1.9-.918.95 2.818 2.819ZM7.333 16.67h5.333v-1.333H7.333v1.333Zm0-5.333h5.333v-1.333H7.333v1.333Z"
      />
    </g>
  </svg>
);

export default ChecklistIcon;
